/* eslint-disable */
import toast from '../../services/toast';
import { mapGetters } from 'vuex';
import { VueEditor } from "vue2-editor";
export default {
  name: 'public-edit-quiz',
  components: {
    VueEditor
  },
  props: [],
  data() {
    return {
      quizData: {
        courseId: '',
        name: '',
        category: '',
        instruction: '',
        quiz_number: 0,
        time_limit:90,
        isActive: false,
        quizId:''
      },
      submitted:false,
      QuizList:null,
      is_active:'',
      coursesCategory: {},
      pub_catID:'',
      editorOptions: {
        placeholder: '',
        editorToolbar: ['bold','italic','link',  '|', 'heading', 'fontFamily','fontSize','undo','redo']
      },
      instruction:''
    }
  },
  computed: {
    ...mapGetters([
      'getQuizDetailsByIdDataState',
      'getcourseCategoryState'
    ]),
    getCourseList() {
      return this.coursesCategory = this.$store.getters.getcourseCategoryState.data
    },
    getQuizDetails() {
      this.$store.dispatch('getQuizDetailsByIdFun', {
        id: this.$route.params.quizId
      }).then((response) => {
        this.quizData.name = this.$store.getters.getQuizDetailsByIdDataState.name
        this.quizData.isActive = this.$store.getters.getQuizDetailsByIdDataState.is_active
        this.quizData.instruction = this.$store.getters.getQuizDetailsByIdDataState.instruction
        this.quizData.category = this.$store.getters.getQuizDetailsByIdDataState.category.id
        this.quizData.quiz_number = this.$store.getters.getQuizDetailsByIdDataState.quiz_number
        this.quizData.time_limit = this.$store.getters.getQuizDetailsByIdDataState.time_limit
      })
    }
  },
  mounted() {
    this.pub_catID = this.$route.params.quiz_catId,
    this.quizData.quizId = this.$route.params.quizId
  },
  methods: {
    courseQuizStatusAct(quizzId) {
      if (this.quizData.isActive === true) {
        this.is_active = false
      }
      if (this.quizData.isActive === false) {
        this.is_active = true
      }
      let data = {
        is_active: this.is_active,
        name: this.quizData.name,
        instruction: this.quizData.instruction,
        category: this.quizData.category,
        quiz_number:this.quizData.quiz_number,
        time_limit: this.quizData.time_limit
      }
      this.$store.dispatch('updateQuizFun', {
        data: {
          data: data,
          id: quizzId
        }
      }).then((res) => {
        if (res.status == '200') {
          this.quizData.isActive = res.data.data.is_active
          toast.success("Quiz Status Updated Successfully");
        }
      }).catch((err) => {})
      return
    },
    validateUpdateQuizBeforeSubmit(e) {
      this.$validator.validateAll().then((result) => {
        this.submitted = true;
        if (result) {
          let data = { 
            name: this.quizData.name,
            instruction: this.quizData.instruction,
            category: this.quizData.category,
            quiz_number:this.quizData.quiz_number
          }
          this.$store.dispatch('updateQuizFun', {
              data: {
                data: data,
                id: this.$route.params.quizId
              }
            }).then((res) => {
              if (res.status == '200') {
                toast.success(res.data.msg);
                this.$router.push('/course/public/quizzes/category/' + this.pub_catID + '/list/' )
              }
            })
            .catch((err) => {})
          return
        }
      });
    }
  },
  beforeMount() {
    this.getQuizDetails
    this.getCourseList
  },
  watch: {
    getCourseList() {
      return this.coursesCategory = this.$store.getters.getcourseCategoryState.data
    },
  }
}